export default __webpack_public_path__ + "static/media/logo.ddedc46b.svg";